import React from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { UserSessionProvider } from './contexts/UserContext';
import { SharePointProvider } from './contexts/SharePointContext';
import Header from './components/Header';
import AppRoutes from './AppRoutes';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

axios.defaults.withCredentials = true;

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <UserSessionProvider>
            <SharePointProvider>
              <div className="App">
                <Header />
                <AppRoutes />
              </div>
            </SharePointProvider>
          </UserSessionProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
